"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfConflictsFailingPropsDto = instanceOfConflictsFailingPropsDto;
exports.ConflictsFailingPropsDtoFromJSON = ConflictsFailingPropsDtoFromJSON;
exports.ConflictsFailingPropsDtoFromJSONTyped = ConflictsFailingPropsDtoFromJSONTyped;
exports.ConflictsFailingPropsDtoToJSON = ConflictsFailingPropsDtoToJSON;
exports.ConflictsFailingPropsDtoToJSONTyped = ConflictsFailingPropsDtoToJSONTyped;
const ShiftConflictDto_1 = require("./ShiftConflictDto");
/**
 * Check if a given object implements the ConflictsFailingPropsDto interface.
 */
function instanceOfConflictsFailingPropsDto(value) {
    if (!('conflicts' in value) || value['conflicts'] === undefined)
        return false;
    return true;
}
function ConflictsFailingPropsDtoFromJSON(json) {
    return ConflictsFailingPropsDtoFromJSONTyped(json, false);
}
function ConflictsFailingPropsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'conflicts': (json['conflicts'].map(ShiftConflictDto_1.ShiftConflictDtoFromJSON)),
    };
}
function ConflictsFailingPropsDtoToJSON(json) {
    return ConflictsFailingPropsDtoToJSONTyped(json, false);
}
function ConflictsFailingPropsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'conflicts': (value['conflicts'].map(ShiftConflictDto_1.ShiftConflictDtoToJSON)),
    };
}
//# sourceMappingURL=ConflictsFailingPropsDto.js.map